<template>
  <slot>
    <div
      v-show="displayedErrors.length > 0"
      class="govuk-error-summary optional-extra-class govuk-error-bag"
      aria-labelledby="error-summary-title"
      role="alert"
      tabindex="-1"
      data-module="govuk-error-summary"
    >
      <h2 class="govuk-error-summary__title" id="error-summary-title">
        {{ t("title", "_errorBag") }}
      </h2>
      <div class="govuk-error-summary__body">
        <p>{{ t("subtitle", "_errorBag") }}</p>
        <ul class="govuk-list govuk-error-summary__list">
          <li v-for="(error, errIndex) in displayedErrors" v-bind:key="errIndex">
            <a v-if="error.control" :href="currentUrl + '#' + error.control.identifier" v-on:click="navigateToTarget(error)"
              ><span v-if="error.control.state.name">{{ error.control.state.name }}: </span>
              {{ (error.errorBagMessage ? error.errorBagMessage : error.message) }}
            </a>
            <a v-else :href="currentUrl + '#' + error.targetId" v-on:click="navigateToTarget(error)">
              {{ (error.errorBagMessage ? error.errorBagMessage : error.message) }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </slot>
</template>
<script lang="ts" src="@/library/builder/ErrorBag.ts"></script>
